import globalTheme from '../global'

const List = {
	MuiMenu: {
		styleOverrides: {
			list: {
				borderRadius: globalTheme.shape.borderRadius,
				border: '1px solid ' + globalTheme.palette.primary.main,
				marginTop: globalTheme.spacing(1),
				padding: 0,
			},
		},
	},
	MuiMenuItem: {
		defaultProps: {
			disableRipple: true,
		},
		styleOverrides: {
			root: {
				color: globalTheme.palette.primary.main,
				padding: '13px 23px',
				borderBottom: '1px solid ' + globalTheme.palette.grey.light,
				whiteSpace: 'normal',
				'&:not(.Mui-disabled)': {
					borderTopLeftRadius: globalTheme.shape.borderRadius,
					borderTopRightRadius: globalTheme.shape.borderRadius,

					'&:hover': {
						borderTopLeftRadius: globalTheme.shape.borderRadius,
						borderTopRightRadius: globalTheme.shape.borderRadius,
					},
				},
				'&:last-of-type': {
					borderBottom: 0,
					borderBottomLeftRadius: globalTheme.shape.borderRadius,
					borderBottomRightRadius: globalTheme.shape.borderRadius,
				},
				'&.Mui-disabled': {
					color: globalTheme.palette.grey.main,
				},
				'&.Mui-selected': {
					backgroundColor: globalTheme.palette.ghost.hover,
					color: globalTheme.palette.grey.main,
				},
				'&.Mui-focusVisible': {
					backgroundColor: globalTheme.palette.ghost.hover,
					color: globalTheme.palette.primary.main,
				},
				'&:hover': {
					backgroundColor: globalTheme.palette.ghost.hover,
					color: globalTheme.palette.grey.main,
				},
			},
		},
	},
}

export default List
